import { makeAutoObservable } from "mobx";
import { EFManagementService } from "../../EmissionFactorManagement/service/EFManagementService";
import {
  MESSAGE_CODES,
  showSuccessToast,
  handleAPIError,
} from "../../services/toast";
import commonStore from "./commonStore";
import { importJobAPI } from "../../ExcelImportExportModal/API/importJobAPI.js";
import { emissionFactorManagementAPI } from "../../EmissionFactorManagement/API/emissionFactorManagementAPI";
import {
  getEditableSubTreeIds,
  getFilterCom,
} from "../../EmissionView/utils/getFilterCom";

const service = EFManagementService;

const getScopeCompanyIds = () =>
  commonStore.scopeType === "COMPANY"
    ? getEditableSubTreeIds(
        commonStore.companyTreeRootId,
        commonStore.companyList,
      )
    : getFilterCom(
        commonStore.orgList,
        commonStore.authId,
        commonStore.rootId,
      );

class EFManagementStore {
  ////////選擇哪個category
  addCustomEFData = {};

  ////////顯示新增自定義的表單
  ifShowAddCustomModal = false;

  ////////自定義係數表單是否為修改
  isEditCustomModal = false;

  ////////EFManagement頁面cat下拉式選單
  EFManagementCat = [];

  ////////選擇哪個category
  selectedScope = { label: "All Category", value: [] };

  ////////選擇的公司
  selectedCom = [];

  ////////是否顯示確認修改的提示Modal
  isShowEditConfirmModal = false;

  ////////是否為刪除自定義
  isDeleteCustomEF = false;

  ////////是否loading
  EFManagementLoading = false;

  ////////自定義list
  customEFList = [];

  ////////cId
  companyId = "";

  ////////parentId
  parentId = "";

  ////////自定義Excel
  isShowCustomEFExcelModal = false;

  ////////自定義Excel上傳提醒
  isShowCustomEFExcelModalWarning = false;

  ////////list目前的頁碼
  currentCustomEFListPage = 1;
  customEFPageSize = 10;

  ////////總共的頁碼
  totalPage = 0;

  ////////搜尋的關鍵字
  searchKeyword = "";

  ////////所有的公司集合
  allCompanyList = [];

  ////////顯示Custom Excel confirm Modal
  isShowCustomEFExcelConfirmModal = false;

  ////////file
  file = null;

  ////////自定義表單選擇公司
  customSelectedCom = "";

  ////////自定義公司下拉式選單
  customComDropdownList = [];

  ////////選擇的頁面
  selectedEFPage = 0;

  ////////平台資料庫search
  systemSearchKeyword = "";

  ////////平台資料庫類別
  systemCat = "";

  ////////平台資料庫來源
  systemSource = 0;

  ////////平台資料庫單位
  systemUnit = 0;

  ////////顯示平台資料庫詳細資料
  isShowSystemDetail = false;

  ////////平台資料庫詳細資料
  systemDatabaseDetail = {};

  ////////顯示佐證上傳功能
  isShowValidationFileModal = false;

  ////////顯示預覽功能
  isShowCustomEFPreviewModal = false;

  ////////佐證loading 狀態
  validationFileListLoading = false;

  ////////佐證檔案清單
  validationFileListData = [];

  ////////previewInfo資訊
  customEFDataPreviewData = {};

  ////////
  isExcelModalLoading = false;

  ////////EFExcelWarningContent
  eFExcelWarningContent = [];

  ////////EF List 唯一碼
  EFListUniqueId = 0;

  ////////system List 唯一碼
  systemListUniqueId = 0;

  //////// 選擇標準
  selectedStandard = 1;

  //////// 彈窗的laoding
  isShowModalLoading = false;

  //////// 系統的標準
  systemStandard = 1;

  //////// 離開頁面時重置狀態
  resetState = () => {
    this.selectedEFPage = 0;
    this.selectedStandard = 1;
    this.systemStandard = 1;
    this.selectedScope = { label: "All Category", value: [] };
    this.searchKeyword = "";
    this.systemSearchKeyword = "";
    this.systemCat = "";
    this.systemSource = 0;
    this.systemUnit = 0;
    this.currentCustomEFListPage = 1;
    this.selectedCom = [];
  };
  constructor() {
    makeAutoObservable(this);
  }

  ////////更新拿到表單的物件
  _handleSetCustomEFData = (data) => {
    this.addCustomEFData = {
      ...this.addCustomEFData,
      ...data,
    };
    console.log(JSON.stringify(this.addCustomEFData));
  };

  ////////清除addCustomdata
  _handleClearCustomData = () => {
    this.addCustomEFData = {};
  };

  ////////更新顯示自定義表單的狀態
  _handleSetIfShowAddCustomModal = () => {
    this.ifShowAddCustomModal = !this.ifShowAddCustomModal;
    console.log(`ifShowAddCustomModal: ${this.ifShowAddCustomModal}`);
  };

  ////////更新修改自定義表單狀態
  _handleSetIsEditCustomModal = () => {
    this.isEditCustomModal = !this.isEditCustomModal;
  };

  ////////更新EFManagementCat
  _handleSetEFManagementCat = (data) => {
    this.EFManagementCat = data;
  };

  ////////更新選擇的category
  _handleSetSelectedScope = (label, value) => {
    this.selectedScope.label = label;
    this.selectedScope.value = value;
    console.log(JSON.stringify(this.selectedScope));
  };

  ////////更新選擇的公司
  _handleSetSelectedCom = (data) => {
    this.selectedCom = data;
    this._handleResetCurrentEFListPage();
    console.log(JSON.stringify(this.selectedCom));
  };

  ////////更新是否顯示確認修改的Modal
  _handleSetIfShowEditConfirmModal = (value) => {
    this.isShowEditConfirmModal = value;
  };

  ////////更新是否顯示佐證上傳的Modal
  _handleSetIfShowValidationFileModal = () => {
    this.isShowValidationFileModal = !this.isShowValidationFileModal;
  };

  ////////更新是否為刪除自定義
  _handleSetIfDeleteCustomEF = (value) => {
    this.isDeleteCustomEF = value;
  };

  ////////更新EFManagementLoading 狀態
  _handleSetEFManagementLoading = (value) => {
    if (value === true) {
      this._startEFManagementLoading();
    } else {
      this._stopEFManagementLoading();
    }
  };

  _startEFManagementLoading() {
    if (this.EFManagementLoading) return;

    this._loadingStartAt = Date.now();
    this.EFManagementLoading = true;
  }

  _stopEFManagementLoading(minDuration = 600, closeDelay = 200) {
    const elapsed = Date.now() - this._loadingStartAt;
    const remain = Math.max(minDuration - elapsed, 0);

    if (this._loadingTimer) {
      clearTimeout(this._loadingTimer);
    }

    this._loadingTimer = setTimeout(() => {
      this.EFManagementLoading = false;
      this._loadingTimer = null;
    }, remain + closeDelay);
  }

  ////////更新自定義lsit
  _handleSetCustomEFList = (data) => {
    this.customEFList = data;
  };

  _handleMarkCustomEFUpdateRead = (customEFId) => {
    const targetId = String(customEFId);
    this.customEFList = this.customEFList.map((item) =>
      String(item.id) === targetId && item.isNewUpdateRead !== true
        ? { ...item, isNewUpdateRead: true }
        : item,
    );
  };

  ////////更新cId更新cId
  _handleSetCompanyId = (value) => {
    this.companyId = value;
  };

  ////////更新parentId
  _handleSetParentId = (value) => {
    this.parentId = value;
  };

  ////////更新自定義ExcelModal
  _handleSetIfShowCustomEFExcelModal = (value) => {
    this.isShowCustomEFExcelModal = value;
  };

  ////////更新目前的customEFListPage
  _handleSetCurrentCustomEFListPage = (value) => {
    if (Number.isInteger(value)) {
      this.currentCustomEFListPage = value;
    } else if (value === "add") {
      if (this.currentCustomEFListPage < this.totalPage) {
        this.currentCustomEFListPage += 1;
      }
    } else if (value === "subtract") {
      if (this.currentCustomEFListPage > 1) {
        this.currentCustomEFListPage -= 1;
      }
    }
  };

  ////////重置customEFListPage為1
  _handleResetCurrentEFListPage = () => {
    this.currentCustomEFListPage = 1;
  };

  _handleSetCustomEFPageSize = (pageSize) => {
    this.customEFPageSize = pageSize;
    this.currentCustomEFListPage = 1;
    this.totalPage = Math.ceil(this.customEFList.length / pageSize);
  };

  ////////計算總共頁碼
  _handleCalculTotalPage = (total) => {
    this.totalPage = Math.ceil(total / this.customEFPageSize);
    if (this.currentCustomEFListPage > Math.max(this.totalPage, 1)) {
      this.currentCustomEFListPage = 1;
    }
  };

  get customEFCurrentPageList() {
    const start =
      (this.currentCustomEFListPage - 1) * this.customEFPageSize;
    return this.customEFList.slice(start, start + this.customEFPageSize);
  }

  ////////更新搜尋關鍵字
  _handleSetSearchKeyword = (word) => {
    this.searchKeyword = word;
    this._handleResetCurrentEFListPage();
  };

  ////////更新所有的公司集合
  _handleSetAllCompanyList = (data) => {
    this.allCompanyList = data;
  };

  ////////更新顯示isShowCustomEFExcelModal
  _handleSetIsShowCustomEFExcelModal = (value) => {
    this.isShowCustomEFExcelConfirmModal = value;
  };

  ////////更新file
  _handleSetFile = (data) => {
    this.file = data;
  };

  ////////更新自定義選擇公司
  _handleSetCustomSelectedCom = (data) => {
    this.customSelectedCom = data;
  };

  ////////更新自定義公司下拉式選單
  _handleSetCustomComDropdownList = (data) => {
    this.customComDropdownList = data;
  };

  ////////更新選擇的EF頁面
  _handleSetEFPage = (value) => {
    this.selectedEFPage = value;
  };

  ////////更新平台資料庫search
  _handleSetSystemSearchKeyword = (value) => {
    this.systemSearchKeyword = value;
    console.log(this.systemSearchKeyword);
  };

  ////////更新平台資料庫類別
  _handleSetSystemCat = (value) => {
    this.systemCat = value;
    console.log(this.systemCat);
  };

  ////////更新平台資料庫來源
  _handleSetSystemSource = (value) => {
    this.systemSource = value;
    console.log(this.systemSource);
  };

  ////////更新平台資料庫單位
  _handleSetSystemUnit = (value) => {
    this.systemUnit = value;
    console.log(this.systemUnit);
  };

  ////////更新顯示平台資料庫詳細資料
  _handleSetIsShowSystemDetail = (value) => {
    this.isShowSystemDetail = value;
  };

  ////////更新平台資料庫詳細資料
  _handleSetSystemDatabaseDetail = (data) => {
    this.systemDatabaseDetail = data;
    console.log(this.systemDatabaseDetail);
  };

  ////////更新佐證清單Loading 狀態
  _handleSetValidationFileListLoading = (value) => {
    this.validationFileListLoading = value;
  };

  ////////更新佐證清單
  _handleSetValidationFileListData(update) {
    if (typeof update === "function") {
      this.validationFileListData = update(this.validationFileListData);
    } else {
      this.validationFileListData = update;
    }
  }

  ////////要不要渲染PreviewModal
  _handleCustomEFPreviewModal = () => {
    this.isShowCustomEFPreviewModal = !this.isShowCustomEFPreviewModal;
  };

  ////////更新拿到Preview的資訊
  _handleSetCustomEFPreviewData(data) {
    this.customEFDataPreviewData = {
      ...this.customEFDataPreviewData,
      ...data,
    };
    console.log("PreviewData", JSON.stringify(this.customEFDataPreviewData));
  }

  ////////更新ExcelModalLoading 狀態
  _handleSetExcelModalLoading = (value) => {
    this.isExcelModalLoading = value;
  };

  ////////更新自定義Excel上傳提醒
  _handleSetCustomEFExcelModalWarning = (value) => {
    this.isShowCustomEFExcelModalWarning = value;
  };

  ////////更新EFExcelWarningContent
  _handleSetEFExcelWarningContent = (data) => {
    this.eFExcelWarningContent = data;
  };

  ////////更新EFList 唯一碼
  _handleSetEFListUniqueId = () => {
    this.EFListUniqueId += 1;
  };

  ////////更新systemList 唯一碼
  _handleSetSystemListUniqueId = () => {
    this.systemListUniqueId += 1;
  };

  ////////更新選擇標準
  _handleSetSelectedStandard = (value) => {
    this.selectedStandard = value;
    /////// 切換標準重置scope
    this.selectedScope = {
      label: value === 1 ? "All Category" : "All Scope",
      value: [],
    };
    this._handleResetCurrentEFListPage();
  };

  //////// 更新彈窗laoding
  _handleSetIsShowModalLoading = (value) => {
    this.isShowModalLoading = value;
  };

  //////// 更新系統係數資料庫標準
  _handleSetSystemStandard = (value) => {
    this.systemStandard = value;
  };

  //////// 取得自定義係數資料
  getCustomEFData = async (rootId) => {
    let uniqueId = this.EFListUniqueId + 1;
    this._handleSetEFListUniqueId();
    this._handleSetEFManagementLoading(true);
    this._handleSetCustomEFList([]);
    this._handleCalculTotalPage(0);

    try {
      const data = await service.fetchCustomEFData(
        rootId,
        this.selectedCom,
        this.selectedScope.value,
        this.selectedStandard,
        this.searchKeyword,
      );

      if (uniqueId === this.EFListUniqueId) {
        const rows = data?.data || [];
        this._handleSetCustomEFList(rows);
        this._handleCalculTotalPage(rows.length);
      }
    } catch (err) {
      console.error(err);
      this._handleSetCustomEFList([]);
    } finally {
      if (uniqueId === this.EFListUniqueId) {
        this._handleSetEFManagementLoading(false);
      }
    }
  };

  //////// 修改自定義係數資料
  editCustomEF = async (authId) => {
    this._handleSetIsShowModalLoading(true);
    try {
      this._handleSetIfShowEditConfirmModal(false);
      this.addCustomEFData.standardId = this.selectedStandard;
      const response = await service.fetchEditEF(
        this.addCustomEFData.id,
        this.addCustomEFData,
      );
      if (response?.success !== false) {
        showSuccessToast({
          apiData: response,
          scenarioCode: MESSAGE_CODES.CUSTOM_EF_UPDATE_SUCCESS,
        });
      }
      this._handleSetIsEditCustomModal();
      this._handleSetIfShowAddCustomModal();
      await this.getCustomEFData(authId);
    } catch (err) {
      console.error(err);
      handleAPIError(err, { throwError: false });
    } finally {
      this._handleSetIsShowModalLoading(false);
    }
  };

  //////////下載自定義Excel
  downloadCustomEFExcel = async () => {
    this._handleSetExcelModalLoading(true);
    const comArr = getScopeCompanyIds();

    await emissionFactorManagementAPI.downloadCustomEFExcel(
      commonStore.scopeId,
      comArr,
      true,
      commonStore.lang,
      this.selectedStandard,
    );
    this._handleSetExcelModalLoading(false);
  };

  //////大量上傳自定義excel
  bulkUploadCustomEFExcel = async (type, file) => {
    const comArr = getScopeCompanyIds();
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append(
        "dto",
        JSON.stringify({
          importType: type,
          companyIds: comArr,
          // file: file,
        }),
      );

      const data = await importJobAPI.submitImportJob(formData);

      if (data.success) {
        showSuccessToast({
          apiData: data,
          scenarioCode: MESSAGE_CODES.FILE_UPLOAD_SUCCESS,
        });
        return data.data?.jobId || data.jobId;
      }
    } catch (err) {
      console.error(err);
      handleAPIError(err);
      return null;
    }
  };
}
const eFManagementStore = new EFManagementStore();
export default eFManagementStore;
